export default "__VITE_ASSET__RArRD_b0__"